import styled from "styled-components";

export const ExcentButton = styled.div`
  background-color: ${(props) => (props.checked ? "#595959" : "#FFFFFF")};
  border-radius: 5px;
  padding: 8px 10px;
  color: ${(props) => (props.checked ? "#FFFFFF" : "#595959")};
  font-family: "Roboto", sans-serif;
  font-weight: 300;
  display: flex;
  flex-direction: row;
  align-items: center;
  column-gap: 5px;
  border: 1px solid #a6a6a6;
  cursor: pointer;
  &:hover {
    border: ${(props) => !props.checked && "1px solid #a6a6a6"};
    background-color: ${(props) => !props.checked && "#f2f2f2"};
  }
`;

export const ExcentCheckbox = styled.input`
  width: 25px;
  height: 25px;
  border: 2px solid #d9d9d9;
  appearance: none; /* Remove default styling */
  cursor: pointer;
  background-color: white; /* Default background */
  position: relative;

  &:checked {
    background-color: black; /* Black background when checked */
    border-color: black;
  }

  &:checked::before {
    content: "";
    position: absolute;
    width: 12px;
    height: 12px;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white; /* White tick effect */
    clip-path: polygon(14% 44%, 0 65%, 50% 100%, 100% 0, 80% 0, 43% 67%);
  }
`;
